module.exports = __webpack_public_path__ + "img/img_comercial3.0e7c5526.png";